module.exports = __webpack_public_path__ + "img/logo_stigler.63ad3cd5.png";